type Filterable = {
    isOrderFulfillment?: boolean;
    beta?: boolean;
};

function createFilter(key: string, inactive: boolean): (x0: Filterable) => boolean {
    return (item) => {
        return inactive || !(key in item && (item as { [k: string]: boolean })[key]);
    };
}

const NaviDefsUtil = {
    createBetaFilter: (showBeta: boolean) => createFilter("beta", showBeta),
    createFilter: createFilter,
    createOfFilter: (showOf: boolean) => createFilter("isOrderFulfillment", showOf)
};

export default NaviDefsUtil;
export { createFilter };

export const { createBetaFilter, createOfFilter } = NaviDefsUtil;
